import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
$(() => {
    RevealWhenVisible.init();
});
